/**
 * Directiva para utilizar el multiselect de jquery
 * Ejemplo:
 *      <select sigo-multiselect multiple
 *          ng-model="opcionSeleccionado"
 *          ng-options="opcion.nombre for opcion in opciones">
 *      </sigo-multiselect>
 */
MultiselectDirective.$inject = ['$timeout', 'lang', '$parse'];
export default function MultiselectDirective($timeout, lang, $parse) {
    var textos = {
        es: {
            todo: 'Todo',
            ninguno: 'Ninguno',
            textoSeleccionados: '# de filtros aplicados',
            placeholder: 'Seleccionar...',
            buscar: 'buscar'
        },
        ca: {
            todo: 'Tot',
            ninguno: 'Cap',
            textoSeleccionados: '# de filtres aplicats',
            placeholder: 'Seleccionar...',
            buscar: 'buscar'
        }
    };
    return {
        restrict: 'EA',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            var placeholder = element.attr('placeholder') ? element.attr('placeholder') : textos[lang].placeholder;

            var options = {
                checkAllText: textos[lang].todo,
                uncheckAllText: textos[lang].ninguno,
                noneSelectedText: placeholder,
                selectedText: textos[lang].textoSeleccionados,
                minWidth: 'auto',
                height: 'auto'
            };

            element.multiselect(options).multiselectfilter({
                placeholder: textos[lang].buscar,
                label: ''
            });


            scope.$watch(attrs.ngModel, function (modelValue) {
                // wait till next cycle to load refreshed data onto DOM
                $timeout(function () {
                    element.multiselect('refresh');
                }, 0, false)
            });
        }
    }
}